import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SharedAdd = _resolveComponent("SharedAdd")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.b())
  }, [
    _createElementVNode("section", {
      class: _normalizeClass(_ctx.b('section')),
      style: {"--d":"80ms"}
    }, [
      _createElementVNode("h3", {
        class: _normalizeClass(_ctx.b('title'))
      }, _toDisplayString(_ctx.$t("Банковские реквизиты")), 3),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('cards'))
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bankRequisites, (requisite) => {
          return (_openBlock(), _createBlock(_component_SharedAdd, {
            key: requisite.id,
            "is-confirmed": true,
            "is-loading": _ctx.isLoading,
            onClick: ($event: any) => (_ctx.handleBank(requisite)),
            onRemove: ($event: any) => (_ctx.handleBankRemove(requisite))
          }, {
            title: _withCtx(() => [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("Банковский счет")), 1),
              _createElementVNode("small", null, _toDisplayString(requisite.name), 1)
            ]),
            label: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("Подтверждено")), 1)
            ]),
            _: 2
          }, 1032, ["is-loading", "onClick", "onRemove"]))
        }), 128)),
        (_ctx.isBankAddShow)
          ? (_openBlock(), _createBlock(_component_SharedAdd, {
              key: 0,
              "is-loading": _ctx.isLoading,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleBank()))
            }, {
              label: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("Добавить")), 1)
              ]),
              _: 1
            }, 8, ["is-loading"]))
          : _createCommentVNode("", true)
      ], 2)
    ], 2),
    _createElementVNode("section", {
      class: _normalizeClass(_ctx.b('section', { crypto: true })),
      style: {"--d":"130ms"}
    }, [
      _createElementVNode("h3", {
        class: _normalizeClass(_ctx.b('title'))
      }, _toDisplayString(_ctx.$t("Крипто реквизиты")), 3),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('cards'))
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cryptoRequisites, (requisite) => {
          return (_openBlock(), _createBlock(_component_SharedAdd, {
            key: requisite.id,
            "is-confirmed": true,
            "is-loading": _ctx.isLoading,
            onClick: ($event: any) => (_ctx.handleCrypto(requisite)),
            onRemove: ($event: any) => (_ctx.handleCryptoRemove(requisite))
          }, {
            title: _withCtx(() => [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("Крипто счет")), 1),
              _createElementVNode("small", null, _toDisplayString(requisite.name), 1)
            ]),
            label: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("Подтверждено")), 1)
            ]),
            _: 2
          }, 1032, ["is-loading", "onClick", "onRemove"]))
        }), 128)),
        (_ctx.isCryptoAddShow)
          ? (_openBlock(), _createBlock(_component_SharedAdd, {
              key: 0,
              "is-loading": _ctx.isLoading,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleCrypto()))
            }, {
              label: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("Добавить")), 1)
              ]),
              _: 1
            }, 8, ["is-loading"]))
          : _createCommentVNode("", true)
      ], 2)
    ], 2)
  ], 2))
}